import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

class LoadingIndicator extends Component {
    static propTypes = {
        className: PropTypes.string
    };

    render = () => (
        <div className={cns('loadingIndicator', this.props.className)}>
            <i className={'spinner fa fa-spinner fa-spin'} />
        </div>
    );
}

export default LoadingIndicator;
